module.exports = __webpack_public_path__ + "img/pattern-6.369dc0cd.jpg";